import React from 'react';
import { FDTable, FDTableBody } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import {
  ConnectionAccountLineItem,
} from 'Views/Page/Content/Templates/ConnectionsPageTemplate/ConnectionAccountLineItem';

export const ConnectionAccounts = ({
  isMobile,
  connectionAccountsCollection,
  onEditLineItemClick,
}) => {
  return (
    <FDTable>
      <FDTableBody>
        {connectionAccountsCollection.resources().list().map((account) => {
          return (
            <ConnectionAccountLineItem
              isMobile={isMobile}
              lineItemResource={account}
              onEditClick={onEditLineItemClick}
            />
          );
        })}
      </FDTableBody>
    </FDTable>
  );
};

ConnectionAccounts.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  connectionAccountsCollection: PropTypes.object.isRequired,
  onEditLineItemClick: PropTypes.func.isRequired,
};
